import script from "./ProjectExpenseSavingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectExpenseSavingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectExpenseSavingsPage.vue?vue&type=style&index=0&id=7408dc98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7408dc98"]])

export default __exports__